import angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { StripeService }               from './stripe.service';
import { StripeStatusCtrl }            from './stripe.status.ajs';
import { StripeStatusDirective }       from './stripe.status.directive.ajs';
import { StripeStatusFilter }          from './stripe.status.filter.ajs';
import { StripeStatusPipe }            from './stripe.status.pipe';

angular.module('app-lite.stripe', [])
  .controller('StripeStatusCtrl', StripeStatusCtrl)
  .directive('stripeStatus', StripeStatusDirective)
  .filter('stripeStatus', StripeStatusFilter)
  .service('stripeApi', downgradeInjectable(StripeService))
  .service('stripeStatusPipe', downgradeInjectable(StripeStatusPipe));

